export class VegaLiteDataLimitError extends Error {
  readonly name = 'VegaLiteDataLimitError';
}

export class VegaLiteDataTimeoutError extends Error {
  readonly name = 'VegaLiteDataTimeoutError';

  constructor(deadlineMs: number) {
    super(
      `Float-series retrieval exceeded the ${deadlineMs} ms deadline. Try again or reduce the selected data.`,
    );
  }
}

export class VegaLiteDataProtocolError extends Error {
  readonly name = 'VegaLiteDataProtocolError';
}
